module.exports = __webpack_public_path__ + "img/public_filetype_excel_normal.dfa18e04.svg";